import {
  Component,
  OnDestroy,
  OnInit,
  output,
  signal,
  viewChild,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormBaseComponent } from '@goatsports/shared/util';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EjsDialogBaseComponent<
  TData extends {
    [K in keyof TData]: AbstractControl<any>;
  } = any,
>
  extends FormBaseComponent
  implements OnInit, OnDestroy
{
  ejsDialog = viewChild.required(DialogComponent);
  isVisible = signal<boolean>(true);
  onClose = output<void>();

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  beforeOpen() {
    // console.log('before open');
  }

  setDialogVisibility(isVisible: boolean) {
    this.isVisible.set(isVisible);
  }

  showDialog() {
    this.ejsDialog().show();
  }

  closeDialog() {
    this.ejsDialog().hide();
    this.onClose.emit();
  }
}
